<app-modal-dialog title="Your SFTP Information" (dismiss)="cancel()">
    <main>
        <form #form="ngForm">
            <app-layout-row>
                <app-layout-column [width]="12">
                    <app-radiobuttons
                        #sftpType="ngModel"
                        name="type" 
                        caption="Choose the type of SFTP connection you want to use"
                        [ngModel]="transportInternal().Type"
                        displayExpr="text"
                        valueExpr="value"
                        [dataSource]="[
                            { value: 'IntegratedSFTP', text: 'Link Integrated SFTP' },
                            { value: 'SFTPCustomerEndpoint', text: 'Your own SFTP server' }
                        ]"
                        [itemTemplate]="itemTemplate"
                        (ngModelChange)="typeChanged($event)">
                        <ng-template #itemTemplate let-data>
                            <div class="radio-item">{{data.text}}</div>
                        </ng-template>
                    </app-radiobuttons>
                </app-layout-column>
            </app-layout-row>

            @if (sftpType.value === 'SFTPCustomerEndpoint') {
                
                <app-layout-row margin="1rem">
                    <app-layout-column [width]="12">
                        <app-layout-row margin="0rem">
                            <app-layout-column [width]="12">
                                <app-textbox [name]="'field-Hostname'" [caption]="'Host name'" [ngModel]="hostname()" required></app-textbox>
                            </app-layout-column>
                        </app-layout-row>
                        <app-layout-row margin="0rem">
                            <app-layout-column [width]="12">
                                <app-textbox [name]="'field-Port'" [caption]="'Port'" [ngModel]="port()" required></app-textbox>
                            </app-layout-column>
                        </app-layout-row>
                        <app-layout-row margin="0">
                            <app-layout-column [width]="12">
                                <app-textbox [name]="'field-InFolder'" [caption]="'Inbound folder'" [ngModel]="inboundFolder()" required></app-textbox>
                            </app-layout-column>
                        </app-layout-row>
                        <app-layout-row margin="0">
                            <app-layout-column [width]="12">
                                <app-textbox [name]="'field-OutFolder'" [caption]="'Outbound folder'" [ngModel]="outboundFolder()" required></app-textbox>
                            </app-layout-column>
                        </app-layout-row>
                    </app-layout-column>
                </app-layout-row>

                <app-layout-row margin="2rem">
                    <app-layout-column [width]="12">
                        <app-layout-row margin="0">
                            <app-layout-column [width]="12">
                                <app-checkbox 
                                    #showCredentials="ngModel"
                                    name="provideCredentialsNow" 
                                    [ngModel]="!!credentials()" 
                                    (ngModelChange)="provideCredentialsNowChanged($event)"
                                    caption="Provide FTP credentials now. If unchecked your partner can request credentials from you later.">
                                </app-checkbox>
                            </app-layout-column>
                        </app-layout-row>
                        @if (showCredentials.value) {
                            <app-layout-row margin="0">
                                <app-layout-column [width]="12">
                                    <app-textbox [name]="'field-Username'" [caption]="'Username'" [ngModel]="credentials()?.Username" required></app-textbox>
                                </app-layout-column>
                            </app-layout-row>
                            <app-layout-row margin="0">
                                <app-layout-column [width]="12">
                                    <app-password [name]="'field-Password'" [caption]="'Password'" [validate]="false" [ngModel]="credentialsPassword()" required [mode]="PasswordMode.Secret" [allowShowPassword]="true"></app-password>
                                </app-layout-column>
                            </app-layout-row>
                        }
                    </app-layout-column>
                </app-layout-row>
            }
        </form>
    </main>

    <footer>
        <div class="button-container">
            <app-button [disabled]="!form.valid" primary (buttonClick)="accept()">Ok</app-button>
            <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
        </div>
    </footer>
</app-modal-dialog>